import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'
import { getRequest, postRequest, patchRequest, deleteRequest } from '@/plugins/api-axios'

@Mixin
export default class UserMixin extends Vue {
    url_user = process.env.VUE_APP_USER_BASE_URL

    get headersmixins() {
        return {
            'Content-Type': 'application/vnd.api+json',
        }
    }

    // USER
    async getGeneralUser(id: string) {
        let url = `${this.url_user}/users/${id}`
        let res = await getRequest(url, this.headersmixins)
        return res.data.data
    }

    async getUsers(params: any) {
        let url = `${this.url_user}/users?include=employer`
        let res = await getRequest(url, this.headersmixins, params)
        let companies = {}
        res.data.included.map((item: any) => {
            switch (item.type) {
                case 'company':
                    companies[item.id] = item
                    break
            }
        })
        res.data.data.map((user: any) => {
            return user.relationships.employer.data
                ? (user.relationships.employer.data =
                      companies[user.relationships.employer.data.id])
                : null
        })
        return res.data.data
    }

    async getUser(id: string) {
        let url = `${this.url_user}/users/${id}?include=secondaryEmails,employer`
        let res = await getRequest(url, this.headersmixins)

        let secondaryEmails: any = {}
        let company: any = res.data.included?.find((item: any) => {
            return item.type == 'company'
        })

        res.data.included.map((item: any) => {
            switch (item.type) {
                case 'secondaryEmail':
                    secondaryEmails[item.id] = item
                    break
            }
        })

        this.$store.commit('user', res.data.data)
        this.$store.commit('secondaryEmails', {
            ...this.$store.getters.secondaryEmails,
            ...secondaryEmails,
        })
        this.$store.commit('userCompany', company)

        return res.data.data
    }

    async postUser(data: any) {
        let url = `${this.url_user}/users`
        let res = await postRequest(url, this.headersmixins, data)
        return res
    }

    async patchUser(params: any) {
        let url = `${this.url_user}/users/${params.data.id}?include=secondaryEmails,employer`
        let res = await patchRequest(url, this.headersmixins, params.data)
        let secondaryEmails: any = {}
        let company: any = res.data.included?.find((item: any) => {
            return item.type == 'company'
        })

        res.data.included.map((item: any) => {
            switch (item.type) {
                case 'secondaryEmail':
                    secondaryEmails[item.id] = item
                    break
            }
        })

        this.$store.commit('user', res.data.data)
        this.$store.commit('secondaryEmails', {
            ...this.$store.getters.secondaryEmails,
            ...secondaryEmails,
        })
        this.$store.commit('userCompany', company)
        return res.data.data
    }

    filterProjectByAccessibleModules(projects: Array<any>, name: string) {
        let res = projects
            ? projects.filter((project: any) => {
                  return this.$store.getters.projectAccessibleModules(project.id)
                      ? this.$store.getters.projectAccessibleModules(project.id)[name]
                      : false
              })
            : projects

        return res
    }

    // SECONDARY EMAIL

    async postEmail(data: any) {
        let url = `${this.url_user}/secondaryEmails/`
        let res = await postRequest(url, this.headersmixins, data)
        return res
    }

    async deleteEmail(id: string) {
        let url = `${this.url_user}/secondaryEmails/${id}`
        let res = await deleteRequest(url, this.headersmixins)
        return res
    }
}
